// @flow

// Decoders
import decoder from './decoder'
import { toJson } from 'fc-decoders'

// Model Properties
import {
  PROP_SHAPE_DATA,
} from 'fc-model-shapes'

// Exports
export default {
  ...decoder,
  [PROP_SHAPE_DATA]: toJson,
}
